import { publicSiteLocation } from 'config/Vars'

import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'
import companies from 'modules/core/store/collections/companies'
import Constant from 'modules/core/store/models/Constant'

import { companyDefaultDomain } from 'modules/locations/store/collections/locations'

const countryDomainOptions = new Constant({
  id: 'country_domain_options',
})

export async function signOutAndRedirectToCountryDomain({
  redirectToCountryDomain,
}: {
  redirectToCountryDomain: boolean
}) {
  const api = ApiClient()
  await countryDomainOptions.fetch()
  let logoutRedirect = publicSiteLocation

  const domainsList = countryDomainOptions.toJS().value

  if (redirectToCountryDomain && companies.selected && domainsList) {
    logoutRedirect = `https://${companyDefaultDomain(domainsList)}`
  }

  const logoutHref = await api.get('/sessions', {
    uri: logoutRedirect,
  })
  await api.del('/sessions')
  window.location.href = logoutHref.redirect_uri
}
